export default "__VITE_ASSET__DdR4eTu7__"